import { Button, Modal, Box, TextField, InputAdornment } from "@mui/material";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TrunInkAddForm from "./TruInkAddForm";
import {
  gatewaysSchema,
  digitalTagsSchema,
  dataRecordSchema,
  softGatewaysSchema,
} from "../Helpers/formSchemas";
import callPiggybackAPI from "../Helpers/piggyback.api.helper";
import AddTemplateFormModal from "./AddTemplateFormModal";
import AddCollectionModal from "./AddCollectionModal";
import { Upload } from "lucide-react";
import { enqueueSnackbar } from "notistack";
import StoreSettings from "./StoreSettings";
import { ImportButtonHelper } from "../Helpers/ImportButton.helper";
import AddTruInkEMMSModal from "./AddTruInkEMMSModal";
import SearchIcon from "@mui/icons-material/Search";

import { ActionNotSupportedAlert } from "../../ActionNotSupportedAlert";
import { useTheme, useMediaQuery } from "@mui/material";
import { BulkDigitalTagsResult } from "./BulkImportDigitalTagsApiResposeModal";



function TruinkAddImportButtons({ onSaveSuccess, templateSearchValue, setTemplateSearchValues }) {
  const [open, setOpen] = useState(false);
  const [schemaModalOpen, setSchemaModalOpen] = useState(false);
  const selectedSiteOption = useSelector(
    (state) => state.truInk.selectedSiteOption
  );
  const fileInputRef = useRef(null);
  const handleClick = () => {
    fileInputRef.current.click();
  };
  const selectedSite = useSelector((state) => state.truInk.selectedSite);
  const [formData, setFormData] = useState({});
  const [formTitle, setFormTitle] = useState("");
  const [currentSchema, setCurrentSchema] = useState({});
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [isAddCollectionModal, setIsAddCollectionModal] = useState(false);
  const [selectedDataInfoId, setSelectedDataInfoId] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isTruInkEMMSModalOpen, setIsTruInkEMMSModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const truInkState = useSelector((state) => state.truInk);
  const [dataRecords, setDataRecords] = useState([]);
  const {
    handleFileChange,
    handleImportFile,
    fetchDataRecords,
    handleDownload,
    handleSave,
    handleOpenModal,
    handleDownloadDigitalTagsSample,
    handleImportDigitalTags
  } = ImportButtonHelper(
    selectedSite,
    setSelectedFile,
    setIsImportModalOpen,
    setDataRecords,
    enqueueSnackbar,
    truInkState,
    selectedFile,
    setSelectedDataInfoId,
    setOpen,
    selectedSiteOption,
    selectedDataInfoId,
    onSaveSuccess,
    gatewaysSchema,
    digitalTagsSchema,
    dataRecordSchema,
    setFormData,
    setFormTitle,
    setCurrentSchema,
    setSchemaModalOpen,
    setIsAddCollectionModal,
    setIsTruInkEMMSModalOpen
  );
  const siteSchema = useSelector((state) => state.truInk.siteSchema);
  const [showNotSupportedActionModal, setShowNotSupportedActionModal] = useState(false)
  const [softGatewayOpen, setSoftGatewayOpen] = useState(false);
  const [softGatewaySchema, setSoftGatewaySchema] = useState({ ...softGatewaysSchema });
  const [softGatewayFormData, setSoftGatewayFormData] = useState(
    Object.keys(softGatewaysSchema).reduce((acc, key) => {
      acc[key] = softGatewaysSchema[key].initialValue;
      return acc;
    }, {})
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [bulkImportTagResultModalOpen,setBulkImportTagResultModalOpen]=useState(false)
  const [bulkImportTagResult,setBulkImportTagResult]=useState({})

  const handleOpenSoftGatewayModal = async () => {
    const schema = { ...softGatewaysSchema, queue: { ...softGatewaysSchema.queue, options: [] } };
    try {
      const queues = await callPiggybackAPI("queue", {}, {}, "GET");
      if (queues && Array.isArray(queues)) {
        schema.queue.options = queues.map((q) => ({ value: q.id, label: q.name }));
      }
    } catch (err) {
      console.error("Failed to fetch queues for soft gateway:", err);
    }
    setSoftGatewaySchema(schema);
    setSoftGatewayOpen(true);
  };

  const handleSoftGatewaySave = async (updatedData) => {
    if (!selectedSite) return;
    const { id, ...dataWithoutId } = updatedData;
    try {
      await callPiggybackAPI(
        "gateways",
        {},
        { siteId: selectedSite.id, tenantId: selectedSite.tenantId, ...dataWithoutId },
        "POST"
      );
      if (onSaveSuccess) onSaveSuccess();
    } catch (err) {
      console.error("Error saving soft gateway:", err);
    }
    setSoftGatewayOpen(false);
  };

  return (
    <>
    <Box  
      className="truinkAddImportButtons"
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        my:{
          xs:"8px",
          md:0
        },
        gap: {xs:"2vw",md:"1vw"},
      }}
    >
      {selectedSiteOption !== "Reports" && selectedSiteOption !== "Plugins" && (
        <>
          {selectedSiteOption === "SiteTemplates" ? (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              mb={0}
            >
          
              <Button
                variant="contained"
                onClick={() =>{
                  if(isMobile){
                    setShowNotSupportedActionModal(true)
                  }
                  else{
                    setIsTemplateModalOpen(true)
                  }
                }}
                disabled={!selectedSite}
                sx={{
                  textTransform: "none",
                  backgroundColor: "rgb(90, 28, 47)",
                  "&:hover": {
                    backgroundColor: "rgb(90, 28, 35)"
                  },
                  marginRight:'10px',
                  whiteSpace:"nowrap"
                }}
              >
                Add {selectedSiteOption}
              </Button>

              <TextField
                size="small"
                placeholder="Search..."
                value={templateSearchValue}
                variant="standard"
                onChange={(e) => setTemplateSearchValues(e.target.value)}
                sx={{
                  width: "250px",

                  "& .MuiInput-root": {
                    position: "relative",
                    borderBottom: "1px solid #ccc",

                    "&:before": {
                      borderBottom: "1px solid #ccc",
                    },

                    "&:hover:not(.Mui-disabled):before": {
                      borderBottom: "1px solid #aaa",
                    },


                    "&:after": {
                      display: "none",
                    },


                    backgroundImage: "linear-gradient(#666, #666)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "0% 2px",
                    backgroundPosition: "center bottom",
                    transition: "background-size 0.3s ease",

                    "&.Mui-focused": {
                      backgroundSize: "100% 2px",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        marginRight: "2px",
                      }}
                    >
                      <SearchIcon sx={{ fontSize: "18px", color: "#666" }} />
                    </InputAdornment>
                  ),
                }}
              />


            </Box>
          ) : (
            <>
              <Button
                variant="contained"
                onClick={handleOpenModal}
                disabled={!selectedSite}
                sx={{
                  textTransform: "none",
                  backgroundColor: "rgb(90, 28, 47)",
                  "&:hover": {
                    backgroundColor: "rgb(70, 20, 35)",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "rgba(90, 28, 47, 0.4)",
                    color: "#fff",
                  },
                }}
              >
                Add {selectedSiteOption}
              </Button>
              {selectedSiteOption === "Gateways" && (
                <>
                  <Button
                    variant="contained"
                    onClick={handleOpenSoftGatewayModal}
                    disabled={!selectedSite}
                    sx={{
                      textTransform: "none",
                      background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                      color: "#fff",
                      boxShadow: "none",
                      "&:hover": {
                        background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                        opacity: 0.95,
                        boxShadow: "none"
                      },
                      "&.Mui-disabled": {
                        background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                        opacity: 0.5,
                        color: "#fff"
                      }
                    }}
                  >
                    Add Soft Gateway
                  </Button>
                  <TrunInkAddForm
                    open={softGatewayOpen}
                    onClose={() => setSoftGatewayOpen(false)}
                    data={softGatewayFormData}
                    onSubmit={handleSoftGatewaySave}
                    title="Add Soft Gateway"
                    schema={softGatewaySchema}
                  />
                </>
              )}
            </>
          )}
          {selectedSiteOption === "StoreSettings" && (
            <StoreSettings
              open={schemaModalOpen}
              onClose={() => setSchemaModalOpen(false)}
              selectedSite={selectedSite}
            />
          )}
          <TrunInkAddForm
            open={open}
            onClose={() => setOpen(false)}
            data={formData}
            onSubmit={handleSave}
            title={formTitle}
            schema={currentSchema}
          />

          <AddTemplateFormModal
            open={isTemplateModalOpen}
            onClose={() => setIsTemplateModalOpen(false)}
          />
          <AddCollectionModal
            open={isAddCollectionModal}
            onClose={() => setIsAddCollectionModal(false)}
            onConfirm={(selectedData) => {
              if (selectedData.items.length === 0) {
                return enqueueSnackbar("Please select at least one item.", {
                  variant: "warning",
                  autoHideDuration: 3000,
                  preventDuplicate: true,
                });
              } else {
                handleSave(selectedData)
                  .then(() => {
                    setIsAddCollectionModal(false);
                    onSaveSuccess();
                  })
                  .catch((err) => {
                    enqueueSnackbar("Error saving collection.", {
                      variant: "error",
                      autoHideDuration: 3000,
                      preventDuplicate: true,
                    });
                  });
              }
            }}
            dataRecords={dataRecords}
          />
          <AddTruInkEMMSModal
            open={isTruInkEMMSModalOpen}
            onClose={() => setIsTruInkEMMSModalOpen(false)}
            onConfirm={() => { }}
            dataRecords={dataRecords}
          />

          {(selectedSiteOption === "SiteData" || selectedSiteOption === "Digital Tags") && (
            <>
              <Button
                variant="contained"
                onClick={() => setIsImportModalOpen(true)}
                sx={{
                  textTransform: "none",
                  background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                  color: "#fff",
                  boxShadow: "none",
                  "&:hover": {
                    background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                    opacity: 0.95,
                    boxShadow: "none"
                  }
                }}
              >
                Import
              </Button>

              <Modal
                open={isImportModalOpen}
                onClose={() => setIsImportModalOpen(false)}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "95%",
                    maxWidth:420,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                  }}
                >
               
                  <Box mb={3}>
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#444",
                        fontWeight: 500,
                      }}
                    >
                      Download sample file:
                    </span>
                    <Box mt={1} display="flex" gap={2}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() =>{
                          if(selectedSiteOption === "SiteData"){
                            handleDownload("csv", siteSchema)
                          }
                          else {
                            handleDownloadDigitalTagsSample("csv")
                          }
                      }
                        }
                      >
                        CSV
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() =>{
                         if(selectedSiteOption === "SiteData"){
                         handleDownload("excel", siteSchema)
                      }
                      else{
                        handleDownloadDigitalTagsSample("excel")
                      }
                    }
                      }
                      >
                        Excel
                      </Button>
                    </Box>
                  </Box>

              
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept=".csv, .xlsx"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />

             
                  <div
                    onClick={handleClick}
                    style={{
                      width: "100%",
                      height: "150px",
                      border: "2px dashed #999",
                      borderRadius: "12px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#666",
                      cursor: "pointer",
                      transition: "all 0.2s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#2563eb";
                      e.currentTarget.style.background = "#f0f7ff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#999";
                      e.currentTarget.style.background = "transparent";
                    }}
                  >
                    <Upload
                      size={40}
                      color="#666"
                      style={{ marginBottom: "8px" }}
                    />
                    <span style={{ fontSize: "14px" }}>
                      {selectedFile
                        ? `Selected ${selectedFile.name}`
                        : "Click or drag to upload"}
                    </span>
                  </div>

              
                  <Box mt={3} display="flex" gap={2}>
                    <Button
                      onClick={()=>{
                        if(selectedSiteOption === "SiteData"){
                          handleImportFile()
                        }
                        else {
                           handleImportDigitalTags(setBulkImportTagResult,setBulkImportTagResultModalOpen)
                        }
                      } }
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        color:"white",
                        backgroundColor: "rgb(90, 28, 47)",
                        "&:hover": {
                          backgroundColor: "rgb(70, 20, 35)",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "rgba(90, 28, 47, 0.4)",
                          color: "#fff",
                        },
                      }}
                    >
                      Upload
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => setIsImportModalOpen(false)}
                      sx={{
                        textTransform: "none",
                        background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                        color: "#fff",
                        boxShadow: "none",
                        "&:hover": {
                          background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                          opacity: 0.95,
                          boxShadow: "none"
                        },
                        "&.Mui-disabled": {
                          background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                          opacity: 0.5,
                          color: "#fff"
                        }
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          )}
        </>
      )}

    </Box>

    <ActionNotSupportedAlert 
    open={showNotSupportedActionModal}
    setOpen={setShowNotSupportedActionModal}
    title = "Please use the desktop or android application for a better experience."
    isTruink={true}
/>


    <BulkDigitalTagsResult 
    open={bulkImportTagResultModalOpen}
    onClose={()=>setBulkImportTagResultModalOpen(false)}
    apiResponse={bulkImportTagResult}
    />
    </>
  );
}

export default TruinkAddImportButtons;
